import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  const openPrivacy = () => setActiveModal('privacy');
  const openTerms = () => setActiveModal('terms');
  const closeModal = () => setActiveModal(null);
  return <>
      <footer className="w-full bg-dark-gray text-gray-400 py-8 border-t border-gray-800" data-id="element-16">
        <div className="max-w-4xl mx-auto px-4" data-id="element-17">
          <div className="text-center mb-4" data-id="element-18">
            <p className="mb-4" data-id="element-19">
              © 2026 Blindaje 21. Todos los derechos reservados.
            </p>
            <p className="text-sm mb-4" data-id="element-20">
              Este producto está diseñado para contratistas que buscan
              resultados reales. No es una solución mágica, requiere trabajo y
              aplicación consistente.
            </p>
          </div>

          {/* Legal Links */}
          <div className="flex items-center justify-center gap-4 text-sm" data-id="element-21">
            <button onClick={openPrivacy} className="hover:text-safety-yellow transition-colors underline" aria-label="Ver política de privacidad" data-id="element-22">
              Privacidad
            </button>
            <span className="text-gray-600" data-id="element-23">|</span>
            <button onClick={openTerms} className="hover:text-safety-yellow transition-colors underline" aria-label="Ver términos y condiciones" data-id="element-24">
              Términos
            </button>
          </div>
        </div>
      </footer>

      {/* Privacy Modal */}
      <LegalModal isOpen={activeModal === 'privacy'} onClose={closeModal} title="Política de Privacidad" data-id="element-25">
        <div className="space-y-6 text-industrial-gray" data-id="element-26">
          <p className="text-sm text-gray-500" data-id="element-27">
            Última actualización: Febrero 2026
          </p>

          <section data-id="element-28">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-29">
              1. Información que Recopilamos
            </h3>
            <p className="mb-3" data-id="element-30">
              Cuando adquieres Blindaje 21, recopilamos la información necesaria
              para procesar tu compra y entregarte el producto digital:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-31">
              <li data-id="element-32">Nombre y dirección de correo electrónico</li>
              <li data-id="element-33">
                Información de pago (procesada de forma segura por nuestro
                procesador de pagos)
              </li>
              <li data-id="element-34">
                Dirección IP y datos de navegación para prevención de fraude
              </li>
            </ul>
          </section>

          <section data-id="element-35">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-36">
              2. Uso de tu Información
            </h3>
            <p className="mb-3" data-id="element-37">Utilizamos tu información para:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-38">
              <li data-id="element-39">Procesar tu compra y entregar el producto digital</li>
              <li data-id="element-40">Enviarte el PDF de Blindaje 21 y materiales relacionados</li>
              <li data-id="element-41">Proporcionar soporte al cliente</li>
              <li data-id="element-42">Procesar reembolsos bajo nuestra garantía</li>
              <li data-id="element-43">Cumplir con obligaciones legales</li>
            </ul>
          </section>

          <section data-id="element-44">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-45">
              3. Protección de Datos
            </h3>
            <p data-id="element-46">
              Implementamos medidas de seguridad técnicas y organizativas para
              proteger tu información personal. Todos los pagos se procesan a
              través de plataformas seguras que cumplen con los estándares PCI
              DSS.
            </p>
          </section>

          <section data-id="element-47">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-48">
              4. Cookies y Tecnologías Similares
            </h3>
            <p data-id="element-49">
              Utilizamos cookies esenciales para el funcionamiento del sitio web
              y para analizar el tráfico. No vendemos ni compartimos tus datos
              con terceros para fines publicitarios.
            </p>
          </section>

          <section data-id="element-50">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-51">
              5. Tus Derechos
            </h3>
            <p className="mb-3" data-id="element-52">Tienes derecho a:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-53">
              <li data-id="element-54">Acceder a tu información personal</li>
              <li data-id="element-55">Solicitar la corrección de datos inexactos</li>
              <li data-id="element-56">Solicitar la eliminación de tus datos</li>
              <li data-id="element-57">Retirar tu consentimiento en cualquier momento</li>
            </ul>
          </section>

          <section data-id="element-58">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-59">
              6. Retención de Datos
            </h3>
            <p data-id="element-60">
              Conservamos tu información personal durante el tiempo necesario
              para cumplir con los fines descritos en esta política, a menos que
              la ley requiera un período de retención más largo.
            </p>
          </section>

          <section data-id="element-61">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-62">
              7. Cambios a esta Política
            </h3>
            <p data-id="element-63">
              Podemos actualizar esta política de privacidad ocasionalmente. Te
              notificaremos sobre cambios significativos publicando la nueva
              política en esta página.
            </p>
          </section>

          <section data-id="element-64">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-65">
              8. Contacto
            </h3>
            <p data-id="element-66">
              Si tienes preguntas sobre esta política de privacidad o sobre cómo
              manejamos tu información personal, puedes contactarnos a través de
              los canales de soporte proporcionados con tu compra.
            </p>
          </section>
        </div>
      </LegalModal>

      {/* Terms Modal */}
      <LegalModal isOpen={activeModal === 'terms'} onClose={closeModal} title="Términos y Condiciones" data-id="element-67">
        <div className="space-y-6 text-industrial-gray" data-id="element-68">
          <p className="text-sm text-gray-500" data-id="element-69">
            Última actualización: Febrero 2026
          </p>

          <section data-id="element-70">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-71">
              1. Aceptación de Términos
            </h3>
            <p data-id="element-72">
              Al adquirir Blindaje 21, aceptas estos términos y condiciones en
              su totalidad. Si no estás de acuerdo con alguna parte de estos
              términos, no debes realizar la compra.
            </p>
          </section>

          <section data-id="element-73">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-74">
              2. Descripción del Producto
            </h3>
            <p className="mb-3" data-id="element-75">
              Blindaje 21 es un producto digital que incluye:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-76">
              <li data-id="element-77">PDF completo con plan de acción de 21 días</li>
              <li data-id="element-78">Guiones de WhatsApp para reactivación de clientes</li>
              <li data-id="element-79">Sistema de Micro-Licitación paso a paso</li>
              <li data-id="element-80">Estrategias de cierre para primera visita</li>
              <li data-id="element-81">Plantillas listas para usar</li>
            </ul>
            <p className="mt-3" data-id="element-82">
              Este es un producto informativo y educativo. Los resultados
              dependen de tu aplicación y esfuerzo individual.
            </p>
          </section>

          <section data-id="element-83">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-84">
              3. Precio y Pago
            </h3>
            <p data-id="element-85">
              El precio de Blindaje 21 es de $6.39 USD (pago único, sin
              suscripciones). Este precio es promocional y puede cambiar sin
              previo aviso. Una vez completada tu compra, recibirás acceso
              inmediato al producto digital.
            </p>
          </section>

          <section data-id="element-86">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-87">
              4. Política de Reembolso
            </h3>
            <p data-id="element-88">
              Ofrecemos una garantía de devolución total de 21 días. Si aplicas
              el sistema durante 21 días y no ves resultados, te devolvemos tu
              dinero completo sin preguntas. Para solicitar un reembolso, debes
              contactarnos dentro del período de garantía.
            </p>
          </section>

          <section data-id="element-89">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-90">
              5. Propiedad Intelectual
            </h3>
            <p data-id="element-91">
              Todo el contenido de Blindaje 21, incluyendo textos, gráficos,
              logos y materiales, está protegido por derechos de autor.
              Adquieres una licencia personal no transferible para usar el
              material. No puedes reproducir, distribuir o vender el contenido
              sin autorización expresa.
            </p>
          </section>

          <section data-id="element-92">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-93">
              6. Descargo de Responsabilidad
            </h3>
            <p className="mb-3" data-id="element-94">
              Blindaje 21 proporciona información y estrategias basadas en
              experiencia práctica. Sin embargo:
            </p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-95">
              <li data-id="element-96">No garantizamos resultados específicos</li>
              <li data-id="element-97">
                Los resultados varían según el esfuerzo individual y
                circunstancias
              </li>
              <li data-id="element-98">
                No somos responsables de decisiones comerciales tomadas
                basándose en el contenido
              </li>
              <li data-id="element-99">Este producto requiere trabajo y aplicación consistente</li>
            </ul>
          </section>

          <section data-id="element-100">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-101">
              7. Limitación de Responsabilidad
            </h3>
            <p data-id="element-102">
              En ningún caso seremos responsables por daños indirectos,
              incidentales, especiales o consecuentes que resulten del uso o la
              imposibilidad de usar el producto, incluso si hemos sido
              advertidos de la posibilidad de tales daños.
            </p>
          </section>

          <section data-id="element-103">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-104">
              8. Uso Aceptable
            </h3>
            <p className="mb-3" data-id="element-105">Al usar Blindaje 21, aceptas:</p>
            <ul className="list-disc pl-6 space-y-2" data-id="element-106">
              <li data-id="element-107">Usar el material solo para fines legales</li>
              <li data-id="element-108">No compartir tu acceso con terceros</li>
              <li data-id="element-109">No reproducir o distribuir el contenido</li>
              <li data-id="element-110">Cumplir con todas las leyes aplicables en tu jurisdicción</li>
            </ul>
          </section>

          <section data-id="element-111">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-112">
              9. Modificaciones
            </h3>
            <p data-id="element-113">
              Nos reservamos el derecho de modificar estos términos en cualquier
              momento. Los cambios entrarán en vigor inmediatamente después de
              su publicación. Tu uso continuado del producto después de los
              cambios constituye tu aceptación de los nuevos términos.
            </p>
          </section>

          <section data-id="element-114">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-115">
              10. Ley Aplicable
            </h3>
            <p data-id="element-116">
              Estos términos se rigen por las leyes aplicables sin tener en
              cuenta conflictos de disposiciones legales. Cualquier disputa se
              resolverá en los tribunales competentes.
            </p>
          </section>

          <section data-id="element-117">
            <h3 className="font-heading text-2xl text-blueprint-blue mb-3" data-id="element-118">
              11. Contacto
            </h3>
            <p data-id="element-119">
              Si tienes preguntas sobre estos términos y condiciones, puedes
              contactarnos a través de los canales de soporte proporcionados con
              tu compra.
            </p>
          </section>
        </div>
      </LegalModal>
    </>;
}